module.exports = __webpack_public_path__ + "media/merrco/merrco_icon-2713ad71.svg";